// extracted by mini-css-extract-plugin
export var borderRadius = "_aw-4";
export var large = "_aw-3";
export var logoContainer = "_aw-0";
export var nameLogo = "_aw-2";
export var small = "_aw-1";